import React, { Component } from 'react';
import { JSXLike } from '../../../../../models/Global';
import * as Styles from './Styles';

type Props = {
	label: JSXLike;
	onClick: () => void;
	selected: boolean;
	style?: React.CSSProperties;
	className?: string;
};

type State = {};

class Selectable extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.SelectableWrapper
				style={this.props.style}
				selected={this.props.selected}
				onClick={this.props.onClick}
				className={this.props.className}
			>
				{this.props.label}
			</Styles.SelectableWrapper>
		);
	}
}

export default Selectable;
